<template>
    <Headers />
    <section class="hero-home">
      <!-- Animated Gradient Background -->
      <div class="hero-background">
        <div class="gradient-layer"></div>
        <div class="pattern-layer"></div>
        </div>

      <!-- Hero Content -->
      <div class="hero-content">
      <!-- Logo Section -->
        <div class="hero-logo">
        <div class="logo-container">
          <h1 class="brand-name">TraviPack</h1>
          <p class="hero-tagline">Envío de paquetes rápido y seguro</p>
                </div>
              </div>

      <!-- Call to Action Card -->
      <div class="cta-card">
        <h2 class="cta-title">¿Necesitas enviar un paquete?</h2>
        <p class="cta-description">
          Conectamos tus envíos con nuestra red de colaboradores profesionales
        </p>

        <button class="main-cta-button" @click="goToShipmentRequest">
          <span>Solicitar Envío</span>
            <i class="fa fa-arrow-right"></i>
                    </button>

        <p class="cta-note">
          ¿Ya tienes cuenta? <router-link to="/login" class="login-link">Inicia sesión</router-link>
        </p>
      </div>
      
      <!-- Track Shipment Section -->
      <div class="track-shipment-card">
        <div class="track-header">
          <span class="track-icon">🔍</span>
          <h3 class="track-title">Rastrea tu envío</h3>
              </div>
        <p class="track-description">
          Ingresa tu número de seguimiento para ver el estado de tu paquete
        </p>
        <form @submit.prevent="trackShipment" class="track-form">
          <div class="track-input-group">
            <input 
              v-model="trackingNumber" 
              type="text" 
              placeholder="Ej: TRV-ABC123 o CONS-XXXXX"
              class="track-input"
              @input="trackingNumber = trackingNumber.toUpperCase()"
            />
            <button type="submit" class="track-button" :disabled="!trackingNumber.trim()">
              <span v-if="!isTracking">Rastrear</span>
              <span v-else>Buscando...</span>
            </button>
          </div>
        </form>
        </div>
      </div>
    </section>

  </template>

  <script>
import Headers from '../components/Headers.vue';
import Footer from '../components/Footer.vue';
  import auth from '@/logic/auth';

  export default {
  name: 'Landing',
  components: { 
    Headers, 
    Footer 
  },
      data() {
      return {
      trackingNumber: '',
      isTracking: false
    };
  },
  async mounted() {
    // Redirect if already logged in
    const personType = await auth.getPersonType();
    const userLogged = await auth.getUserLogged();
    
    if (userLogged) {
      if (personType === 'partner') {
        this.$router.push('/partner');
      } else if (personType === 'staff') {
        this.$router.push('/staff');
      } else if (personType === 'user') {
        // Usuario puede quedarse en landing o ir a sus paquetes
        // this.$router.push('/user/packages');
      }
    }
  },
  methods: {
    async goToShipmentRequest() {
      // Verificar si el usuario está logueado
      const userLogged = await auth.getUserLogged();
      
      if (!userLogged) {
        // Guardar intención de ir a solicitud y redirigir a login
        this.$swal({
          title: 'Inicia Sesión',
          text: 'Necesitas iniciar sesión para solicitar un envío',
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: 'Iniciar Sesión',
          cancelButtonText: 'Registrarse'
        }).then((result) => {
          if (result.isConfirmed) {
            localStorage.setItem('redirectAfterLogin', '/request-shipment');
            this.$router.push('/login');
          } else if (result.isDismissed) {
            this.$router.push('/register');
          }
        });
      } else {
        // Ir directamente al flujo de solicitud
        this.$router.push('/request-shipment');
      }
    },
    
    trackShipment() {
      const tracking = this.trackingNumber.trim();
      if (!tracking) {
        this.$swal({
          title: 'Campo vacío',
          text: 'Por favor ingresa un número de seguimiento',
          icon: 'warning',
          confirmButtonColor: '#009245'
        });
        return;
      }
      
      // Navegar a la página pública de tracking
      this.$router.push(`/track/${tracking}`);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';
@import '@/styles/components/landing-hero.scss';

.hero-logo {
  text-align: center;
  margin-bottom: $spacing-8;

  .logo-container {
    .brand-name {
      font-size: 4rem;
      font-weight: $font-extrabold;
      color: white;
      margin-bottom: $spacing-2;
      text-shadow: 0 4px 6px rgba(0,0,0,0.3);
      letter-spacing: -1px;
    }

    .hero-tagline {
      font-size: $font-xl;
      color: rgba(255, 255, 255, 0.95);
      margin: 0;
      text-shadow: 0 2px 4px rgba(0,0,0,0.2);
    }
  }
}

.cta-card {
  background: white;
  border-radius: $spacing-4;
  padding: $spacing-4;
  max-width: 600px;
  margin: 0 auto $spacing-3;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);

  .cta-title {
    font-size: $font-2xl;
    font-weight: $font-bold;
    color: #2c3e50;
    text-align: center;
    margin-bottom: $spacing-3;
  }

  .cta-description {
    text-align: center;
    color: #6c757d;
    font-size: $font-base;
    margin-bottom: $spacing-6;
  }

  .main-cta-button {
    width: 100%;
    padding: $spacing-4 $spacing-6;
    background: linear-gradient(135deg, #009245 0%, #007a38 100%);
    color: white;
    border: none;
    border-radius: $spacing-2;
    font-size: $font-lg;
    font-weight: $font-bold;
    cursor: pointer;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: $spacing-3;
    box-shadow: 0 4px 12px rgba(0, 146, 69, 0.3);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(0, 146, 69, 0.4);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .cta-note {
    text-align: center;
    margin-top: $spacing-4;
    color: #6c757d;
    font-size: $font-sm;

    .login-link {
      color: #009245;
      font-weight: $font-semibold;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.track-shipment-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: $spacing-4;
  padding: $spacing-3;
  max-width: 600px;
  margin: 0 auto $spacing-3;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  border: 2px solid rgba(0, 146, 69, 0.2);

  .track-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: $spacing-3;
    margin-bottom: $spacing-3;

    .track-icon {
      font-size: 2rem;
    }

    .track-title {
      font-size: $font-xl;
      font-weight: $font-bold;
      color: #2c3e50;
      margin: 0;
    }
  }

  .track-description {
    text-align: center;
    color: #6c757d;
    font-size: $font-sm;
    margin-bottom: $spacing-4;
  }

  .track-form {
    .track-input-group {
      display: flex;
      gap: $spacing-3;
      
      @media (max-width: 576px) {
        flex-direction: column;
      }

      .track-input {
        flex: 1;
        padding: $spacing-3 $spacing-4;
        border: 2px solid #e0e0e0;
        border-radius: $spacing-2;
        font-size: $font-base;
        font-family: 'Courier New', monospace;
        font-weight: $font-semibold;
        transition: all 0.3s;

        &:focus {
          outline: none;
          border-color: #009245;
          box-shadow: 0 0 0 3px rgba(0, 146, 69, 0.1);
        }

        &::placeholder {
          font-family: inherit;
          color: #adb5bd;
        }
      }

      .track-button {
        padding: $spacing-3 $spacing-6;
        background: linear-gradient(135deg, #2563eb, #1e40af);
        color: white;
        border: none;
        border-radius: $spacing-2;
        font-weight: $font-bold;
        font-size: $font-base;
        cursor: pointer;
        transition: all 0.3s;
        white-space: nowrap;
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);

        &:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(37, 99, 235, 0.4);
        }

        &:active:not(:disabled) {
          transform: translateY(0);
        }

        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        @media (max-width: 576px) {
          width: 100%;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .hero-logo .brand-name {
    font-size: 2.5rem;
  }

  .cta-card {
    padding: $spacing-5;

    .main-cta-button {
      font-size: $font-base;
    }
  }

  .track-shipment-card {
    padding: $spacing-4;
  }
}
  </style>
